import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, PreloadAllModules } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
/*
 * Platform and Environment providers/directives/pipes
 */
import { environment } from 'environments/environment';
import { ROUTES } from './app.routes';
// App is our top level component
import { AppComponent } from './app.component';
import { TokenInterceptor, FilesProvider, ImageReadyService } from './providers';
import { FileViewerComponent } from './files.view.component';
import { NoContentComponent } from './no-content';
import { ImageViewerModule } from '@hallysonh/ngx-imageviewer';
import { FileViewImageComponent } from './file.view.image.component';
import { FileViewBase } from './file.view.directive';
import { FileViewPdfComponent } from './file.view.pdf.component';
import { FileViewUnknownComponent } from './file.view.unknown';
import { FileViewVideoNativeComponent } from './file.view.video';
import { FileView3dComponent } from './file.view.3d.component';
import { FileZipDownload } from './file.zip.download.component';
import '../styles/styles.scss';
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/takeWhile';
import 'rxjs/add/operator/publishReplay';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/take';
import 'rxjs/add/observable/throw';
import * as PDFJS from "pdfjs-dist";
import 'hammerjs';

// Application wide providers

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [ AppComponent ],
  declarations: [
    AppComponent,
    FileViewerComponent,
    FileViewImageComponent,
    FileViewBase,
    FileViewPdfComponent,
    FileViewUnknownComponent,
    FileViewVideoNativeComponent,
    FileView3dComponent,
    FileZipDownload,
    NoContentComponent
  ],
  /**
   * Import Angular's modules.
   */
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ImageViewerModule,
    RouterModule.forRoot(ROUTES),
  ],
  /**
   * Expose our Services and Providers into Angular's dependency injection.
   */
  providers: [
    environment.ENV_PROVIDERS,
    FilesProvider,
    ImageReadyService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts